import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { PrefixUrlPipe } from '../../pipes/prefix-url.pipe';
import {
  EventqDialogPopover,
  EventqDialogPopoverPlacement,
} from '../dialog-popover/dialog-popover';
import {
  CAMERA_REPORT_REASON_OPTIONS,
  CameraReportConfirm,
  CameraReportReasonId,
} from './flag-report-popover.types';

export type {
  CameraReportConfirm,
  CameraReportReasonId,
  CameraReportReasonOption,
} from './flag-report-popover.types';
export { CAMERA_REPORT_REASON_OPTIONS } from './flag-report-popover.types';

@Component({
  selector: 'eventq-flag-report-popover',
  imports: [EventqDialogPopover, PrefixUrlPipe],
  templateUrl: './flag-report-popover.html',
  styleUrl: './flag-report-popover.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventqFlagReportPopover {
  readonly open = input(false);
  readonly selectedReasonId = input<CameraReportReasonId | null>(null);
  readonly submitDisabled = input(false);
  readonly anchor = input<HTMLElement | null>(null);
  readonly placement = input<EventqDialogPopoverPlacement | 'auto'>('auto');
  readonly panelWidth = input<string | null>('396px');
  readonly cancelLabel = input('Cancel');
  readonly confirmLabel = input('Submit');
  readonly reasonOptions = input(CAMERA_REPORT_REASON_OPTIONS);

  readonly closed = output<void>();
  readonly confirm = output<CameraReportConfirm>();
  readonly selectedReasonIdChange = output<CameraReportReasonId>();

  readonly resolvedPlacement = computed((): EventqDialogPopoverPlacement => {
    const placement = this.placement();
    if (placement !== 'auto') {
      return placement;
    }

    return this.anchor() ? 'anchor-top-end' : 'center';
  });

  readonly confirmDisabled = computed(() => !this.selectedReasonId() || this.submitDisabled());

  onSelect(reasonId: CameraReportReasonId): void {
    this.selectedReasonIdChange.emit(reasonId);
  }

  onConfirm(): void {
    const reasonId = this.selectedReasonId();
    if (!reasonId) {
      return;
    }

    this.confirm.emit({ reasonId });
  }
}
